import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";

export default () => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            homepageHeader
            homepageAbout
          }
        }
      }
    `}
    render={(data) => (
      <div className="flex items-center justify-center bg-style-bl flex-column pa2 pv5">
        <h1 className="fw1 display db dark-gray f2 tc">
          {" "}
          {data.site.siteMetadata.homepageHeader}{" "}
        </h1>{" "}
        <p className="f4 serif mw7 tc lh-copy">
          {" "}
          {data.site.siteMetadata.homepageAbout}{" "}
        </p>{" "}
        <Link
          to="https://mailchimp.com/"
          className="no-underline mt3 db ph5 pv3 sans-serif near-white br-pill bg-style-pr ttu tracked b hover-bg-mid-gray"
        >
          {" "}
          Get freebies {" "}
        </Link>{" "}
      </div>
    )}
  />
);
